// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "高等数学",
      "tec": "王敏",
      "week": "6-19周",
      "add": "教学楼A座126信息"
    },
    [
      {
        "sub": "交际口语1",
        "tec": "外教6",
        "week": "6-18周",
        "add": "电2"
      },
      {
        "sub": "104国教",
        "tec": "外教9",
        "week": "6-18周",
        "add": "电2"
      },
      {
        "sub": "105国教",
        "tec": "外教8",
        "week": "6-18周",
        "add": "电2"
      },
      {
        "sub": "106国教",
        "tec": "外教7",
        "week": "6-18周",
        "add": "电2"
      }
    ],
    {
      "sub": "就业创业指导",
      "tec": "李乃忠",
      "week": "6-10周",
      "add": "教学楼C座111教务"
    },
    {
      "sub": "人工智能与计算机应用软件",
      "tec": "刘勇",
      "week": "6-17周",
      "add": "实训楼C座303"
    },
    {
      "sub": "军事理论",
      "tec": "王倩",
      "week": "6-14周",
      "add": "教学楼C座113教务"
    }
  ],
  "2": [
    {
      "sub": "电路（上）",
      "tec": "SYED M ALI",
      "week": "6-18周",
      "add": "508国教"
    },
    {
      "sub": "体育",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[03-04节]）"
    },
    [
      {
        "sub": "综合英语1",
        "tec": "于轶",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "109国教",
        "tec": "张珺莹",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "107国教",
        "tec": "张煜",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "404国教",
        "tec": "孙琪",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "106国教",
        "tec": "程子凌",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "104国教",
        "tec": "赵允鹏",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "103国教",
        "tec": "冯威",
        "week": "6-18周",
        "add": "电7"
      },
      {
        "sub": "320国教",
        "tec": "KONG MI",
        "week": "6-18周",
        "add": "电7"
      }
    ],
    {
      "sub": "计算机系统",
      "tec": "刘琪",
      "week": "6-16周",
      "add": "实训楼F座606信机"
    },
    0
  ],
  "3": [
    {
      "sub": "高等数学",
      "tec": "王敏",
      "week": "6-19周",
      "add": "教学楼C座305教务"
    },
    0,
    0,
    0,
    {
      "sub": "形势与政策",
      "tec": "杨淑一",
      "week": "6-9周",
      "add": "教学楼C座306教务"
    }
  ],
  "4": [
    [
      {
        "sub": "综合英语1",
        "tec": "赵允鹏",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "103国教",
        "tec": "程子凌",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "104国教",
        "tec": "孙琪",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "106国教",
        "tec": "张珺莹",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "107国教",
        "tec": "KONG MI",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "108国教",
        "tec": "于轶",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "109国教",
        "tec": "冯威",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "320国教",
        "tec": "张煜",
        "week": "6-18周",
        "add": "电6"
      }
    ],
    {
      "sub": "电路（上）",
      "tec": "SYED M ALI",
      "week": "6-18周",
      "add": "508国教"
    },
    {
      "sub": "心理健康与调适",
      "tec": "韩雪霏",
      "week": "6-15周",
      "add": "教学楼A座421机械"
    },
    {
      "sub": "计算机系统",
      "tec": "刘琪",
      "week": "6-16周",
      "add": "实训楼F座606信机"
    },
    0
  ],
  "5": [
    [
      {
        "sub": "交际口语1",
        "tec": "外教6",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "104国教",
        "tec": "外教9",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "105国教",
        "tec": "外教8",
        "week": "6-18周",
        "add": "电6"
      },
      {
        "sub": "106国教",
        "tec": "外教7",
        "week": "6-18周",
        "add": "电6"
      }
    ],
    {
      "sub": "高等数学",
      "tec": "王敏",
      "week": "6-19周",
      "add": "教学楼A座122信息"
    },
    {
      "sub": "人工智能与计算机应用软件",
      "tec": "刘勇",
      "week": "6-17周",
      "add": "实训楼C座303"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
